import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
// import { environment } from '@environment';
import { ConfigService } from '../../config.service';
import { map } from 'rxjs/operators';
import { JurisdictionalAgency } from '../../../_models';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionalAgenciesService {
  private readonly baseUrl = this.environment.commonUtilityApi.baseUrl;
  private readonly jurisdictionalAgenciesUrl = this.baseUrl + this.environment.commonUtilityApi.jurisdictionalAgencies;
  form: UntypedFormGroup;

  constructor(private http: HttpClient, private environment: ConfigService) { }

  getJurisdictionalAgencies() {
    return this.http.get<JurisdictionalAgency[]>(this.jurisdictionalAgenciesUrl)
      .pipe(map(jurisAgencies => {
        const jurisAgenciesArray = [];
        jurisAgencies.forEach(jAgency => {
          const jAgencyObj = new JurisdictionalAgency(jAgency);
          jurisAgenciesArray.push(jAgencyObj);
        });
        return jurisAgenciesArray.sort((n1, n2) => {
          if (n1.longName > n2.longName) {
            return 1;
          }
          if (n1.longName < n2.longName) {
            return -1;
          }
          return 0;
        });
      }));
  }

}
